export class TabController {
    constructor(host, key, activeTab = 0) {
        this._host = host;
        host.addController(this);
        this.activeTab = activeTab;
        this.key = key;
    }
    updateActiveTab(event) {
        if (this.key === event.detail.key) {
            this.activeTab = event.detail.activeTab;
            this._host.requestUpdate();
        }
    }
    updateNrOfTabs(event) {
        if (this.key === event.detail.key) {
            if (event.detail <= this.nrOfTabs) {
                this.nrOfTabs++;
            }
            else {
                this.nrOfTabs = event.detail;
            }
            this._host.requestUpdate();
        }
    }
    hostConnected() {
        window.addEventListener('setActiveTab', this.updateActiveTab.bind(this));
        window.addEventListener('updateNrOfTabs', this.updateNrOfTabs.bind(this));
    }
    hostDisconnected() {
        window.removeEventListener('setActiveTab', this.updateActiveTab.bind(this));
        window.removeEventListener('updateNrOfTabs', this.updateNrOfTabs.bind(this));
    }
}
//# sourceMappingURL=tabController.js.map